import type { FC } from "react";
import React from "react";

import { Skeleton } from "@react/ui-primitives/skeleton";

import type { MediaAsset } from "@apis/media/models";

interface MediaThumbProps {
  readonly asset: MediaAsset;
  readonly previewUrl: string;
}

const MediaPreview: FC<MediaThumbProps> = ({ asset, previewUrl }) => {
  switch (asset.status) {
    case "awaitingUpload":
      return <Skeleton className="size-full rounded-none" />;
    case "uploaded":
      return (
        <img
          alt={asset.fileName}
          className="size-full object-cover"
          src={previewUrl}
        />
      );
  }
};

export const MediaThumb: FC<MediaThumbProps> = ({ asset, previewUrl }) => (
  <div className="flex flex-col gap-1">
    <div className="aspect-square overflow-hidden rounded-md border bg-muted">
      <MediaPreview asset={asset} previewUrl={previewUrl} />
    </div>
    <p
      className="truncate text-xs text-muted-foreground"
      title={asset.fileName}
    >
      {asset.fileName}
    </p>
  </div>
);
